import { Component } from '@angular/core';

import { DatePipe } from 'bookraw/shared/pipes/date.pipe';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  providers: [ DatePipe ]
})
export class MaintenanceComponent {


}
